export default __webpack_public_path__ + "static/media/animes-bg.b99b8679.jpg";